import { jsx as _jsx } from "react/jsx-runtime";
export function Input({ invalid, className, ...props }) {
    const classes = ['dhk8-input', invalid ? 'dhk8-input--error' : '', className ?? '']
        .filter(Boolean)
        .join(' ');
    return _jsx("input", { className: classes, ...props });
}
export function Textarea({ invalid, className, ...props }) {
    const classes = [
        'dhk8-input',
        'dhk8-input--textarea',
        invalid ? 'dhk8-input--error' : '',
        className ?? '',
    ]
        .filter(Boolean)
        .join(' ');
    return _jsx("textarea", { className: classes, ...props });
}
//# sourceMappingURL=Input.js.map